import toast from "react-hot-toast";
import * as Mui from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CustomAlert = ({ t, type, data }) => {
  return (
    <div
      className={`${
        t.visible ? "animate-enter" : "animate-leave"
      } max-w-lg w-full flex justify-between shadow-lg rounded-lg`}
    >
      <Mui.Alert severity={type} sx={{ width: "100%" }}>
        <div className="w-full flex justify-between">
          <Mui.Typography>{data}</Mui.Typography>
        </div>
      </Mui.Alert>
      <div
        className={`${
          type === "success" ? "bg-[#edf7ed]" : "bg-[#fdeded]"
        } block py-2`}
      >
        <button
          type="button"
          className="block px-3"
          onClick={() => toast.dismiss(t.id)}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;
